import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col" }
const _hoisted_2 = { class: "container mx-auto px-4 pt-3 pb-2 md:pt-6 md:pb-2" }
const _hoisted_3 = { class: "flex items-center justify-between mb-1 md:mb-4" }
const _hoisted_4 = { class: "hidden sm:flex flex-col items-end gap-1" }
const _hoisted_5 = { class: "text-xs text-hk-red font-medium" }
const _hoisted_6 = { class: "flex items-center gap-1 text-sm font-semibold text-hk-dark" }
const _hoisted_7 = ["data-umami-event", "onClick"]
const _hoisted_8 = {
  key: 0,
  class: "text-hk-gray mr-1"
}
const _hoisted_9 = { class: "hidden md:flex items-center gap-8" }
const _hoisted_10 = { class: "ml-auto flex items-center gap-3" }
const _hoisted_11 = {
  href: "https://www.google.com/maps/dir/?api=1&destination=Sleepstraat+186A,+9000+Gent,+Belgium",
  target: "_blank",
  rel: "noopener noreferrer",
  "data-umami-event": "route-click",
  class: "flex items-center gap-1.5 bg-hk-red text-white font-bold uppercase text-sm px-5 py-2.5 rounded-full hover:bg-hk-red-dark transition-colors tracking-wide"
}
const _hoisted_12 = { class: "md:hidden flex items-center justify-between" }
const _hoisted_13 = {
  key: 0,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = {
  key: 1,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = { class: "flex flex-col items-end gap-0.5 sm:hidden min-w-0 pl-3" }
const _hoisted_16 = { class: "text-xs text-hk-red font-medium text-right leading-tight" }
const _hoisted_17 = { class: "flex items-center gap-1 text-sm font-semibold" }
const _hoisted_18 = ["data-umami-event", "onClick"]
const _hoisted_19 = {
  key: 0,
  class: "text-hk-gray mr-1"
}
const _hoisted_20 = {
  key: 0,
  class: "fixed top-0 left-0 z-50 h-full w-72 bg-hk-cream shadow-2xl flex flex-col"
}
const _hoisted_21 = { class: "flex items-center justify-between px-5 pt-6 pb-4 border-b border-hk-cream-dark" }
const _hoisted_22 = { class: "flex-1 overflow-y-auto px-5 py-6 space-y-1" }
const _hoisted_23 = { class: "px-5 pb-6 space-y-3 border-t border-hk-cream-dark pt-4" }
const _hoisted_24 = {
  href: "https://www.google.com/maps/dir/?api=1&destination=Sleepstraat+186A,+9000+Gent,+Belgium",
  target: "_blank",
  rel: "noopener noreferrer",
  "data-umami-event": "route-click-mobile",
  class: "flex items-center justify-center gap-2 w-full bg-hk-red text-white font-bold uppercase text-sm px-5 py-2.5 rounded-full hover:bg-hk-red-dark transition-colors tracking-wide"
}
const _hoisted_25 = { class: "flex-1 relative" }
const _hoisted_26 = { class: "bg-hk-dark text-white section-decorated -mt-px" }
const _hoisted_27 = { class: "container mx-auto px-4 pt-16 pb-10 relative z-10" }
const _hoisted_28 = { class: "flex flex-col md:flex-row items-center md:items-start justify-between gap-10" }
const _hoisted_29 = { class: "text-center md:text-left" }
const _hoisted_30 = { class: "flex flex-col items-center md:items-start gap-2" }
const _hoisted_31 = { class: "text-center md:text-right" }
const _hoisted_32 = { class: "text-sm text-white/80 leading-relaxed space-y-1" }
const _hoisted_33 = { class: "pt-2" }
const _hoisted_34 = {
  href: "https://www.google.com/maps/dir/?api=1&destination=Sleepstraat+186A,+9000+Gent,+Belgium",
  target: "_blank",
  rel: "noopener noreferrer",
  "data-umami-event": "route-click-footer",
  class: "inline-flex items-center gap-2 mt-5 bg-hk-red text-white btn-modern"
}
const _hoisted_35 = { class: "border-t border-white/10 relative z-10" }
const _hoisted_36 = { class: "container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50" }

import { ref, watch, onMounted, onUnmounted } from "vue";
import { useI18n } from "./i18n";
import { useLocaleStore } from "./stores/locale-store";
import type { Locale } from "./stores/locale-store";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const localeStore = useLocaleStore();
const { t, locale } = useI18n();
const mobileMenuOpen = ref(false);
const headerRef = ref<HTMLElement | null>(null);

watch(mobileMenuOpen, (open) => {
  document.body.style.overflow = open ? 'hidden' : '';
});

const navVisible = ref(true);
let lastScrollY = 0;
const headerHeight = ref(0);

const onScroll = (e: Event) => {
  // On mobile (< md breakpoint) the navbar always stays visible
  if (window.innerWidth < 768) {
    navVisible.value = true;
    return;
  }
  let currentY = document.scrollingElement?.scrollTop ?? window.scrollY;
  const target = e.target as EventTarget | null;
  if (target && target !== document && (target as HTMLElement).scrollTop !== undefined) {
    currentY = Math.max(currentY, (target as HTMLElement).scrollTop);
  }
  if (currentY > lastScrollY && currentY > 50) {
    navVisible.value = false;
  } else if (currentY < lastScrollY) {
    navVisible.value = true;
  }
  lastScrollY = currentY;
};

// Tracks header size changes from late-loading web fonts, locale switches and rotation
let headerResizeObserver: ResizeObserver | null = null;

onMounted(() => {
  // capture: true catches scroll events from any scrolling element, not just window
  window.addEventListener("scroll", onScroll, { passive: true, capture: true });
  if (headerRef.value) {
    headerResizeObserver = new ResizeObserver(() => {
      if (headerRef.value) headerHeight.value = headerRef.value.offsetHeight;
    });
    headerResizeObserver.observe(headerRef.value);
  }
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll, { capture: true });
  headerResizeObserver?.disconnect();
});

const locales: Locale[] = ["nl", "fr", "en", "tr"];

const setLocale = (l: Locale) => {
  localeStore.setLocale(l);
};

const navigation = [
  { key: "nav.home", href: "/" },
  { key: "nav.woonlening", href: "/woonlening" },
  { key: "nav.loa", href: "/leningen-op-afbetaling"},
  { key: "nav.leasing", href: "/leasing" },
  { key: "nav.ondernemers", href: "/ondernemers" },
  { key: "nav.verzekeringen", href: "/verzekeringen" },
  { key: "nav.wieZijnWij", href: "/wie-zijn-wij" },
];

const footerLinks = [
  { key: "nav.home", href: "/" },
  { key: "nav.wieZijnWij", href: "/wie-zijn-wij" },
  { key: "footer.simuleer", href: "/#simuleer" },
  { key: "footer.juridisch", href: "/juridische-mededeling" },
  { key: "footer.privacy", href: "/privacy" },
  { key: "nav.contact", href: "/contact" },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      ref_key: "headerRef",
      ref: headerRef,
      class: "fixed left-0 w-full z-50 backdrop-blur-md bg-hk-cream/90 shadow-sm",
      style: _normalizeStyle({ top: navVisible.value ? '0px' : `-${headerHeight.value || 200}px`, transition: 'top 0.3s ease' })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "flex flex-col group"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "text-2xl md:text-3xl font-extrabold tracking-tight" }, [
                _createElementVNode("span", { class: "text-hk-gray transition-colors group-hover:text-hk-dark" }, "HAS"),
                _createElementVNode("span", { class: "text-hk-red" }, "KREDIET")
              ], -1),
              _createElementVNode("span", { class: "text-xs italic text-hk-red tracking-wide" }, "SINCE 1995", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('global.loanCost')), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locales, (lang, i) => {
                return _createElementVNode("button", {
                  key: lang,
                  class: _normalizeClass(_unref(locale) === lang ? 'text-hk-red' : 'text-hk-gray hover:text-hk-dark'),
                  "data-umami-event": `language-${lang}`,
                  onClick: ($event: any) => (setLocale(lang))
                }, [
                  (i > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "/"))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(lang.toUpperCase()), 1)
                ], 10, _hoisted_7)
              }), 64))
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
            return _createVNode(_component_router_link, {
              key: item.key,
              to: item.href,
              class: _normalizeClass([
              'text-sm font-bold uppercase tracking-wide transition-colors',
              _ctx.$route.path === item.href
                ? 'text-hk-red'
                : 'text-hk-dark hover:text-hk-red',
            ])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(item.key)), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          }), 64)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", _hoisted_11, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)('footer.maps')), 1)
            ]),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "bg-hk-red text-white font-bold uppercase text-sm px-6 py-2.5 rounded-full hover:bg-hk-red-dark transition-colors tracking-wide"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('nav.contact')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "text-hk-dark p-1 -ml-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpen.value = !mobileMenuOpen.value))
          }, [
            (!mobileMenuOpen.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 6h16M4 12h16M4 18h16"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  }, null, -1)
                ]))]))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('global.loanCost')), 1),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locales, (lang, i) => {
                return _createElementVNode("button", {
                  key: lang,
                  class: _normalizeClass(_unref(locale) === lang ? 'text-hk-red' : 'text-hk-gray'),
                  "data-umami-event": `language-${lang}`,
                  onClick: ($event: any) => (setLocale(lang))
                }, [
                  (i > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "/"))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(lang.toUpperCase()), 1)
                ], 10, _hoisted_18)
              }), 64))
            ])
          ])
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "border-hk-cream-dark" }, null, -1))
    ], 4),
    _createVNode(_Transition, { name: "mobile-fade" }, {
      default: _withCtx(() => [
        (mobileMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-40 bg-black/40",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuOpen.value = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "mobile-slide" }, {
      default: _withCtx(() => [
        (mobileMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-xl font-extrabold tracking-tight" }, [
                  _createElementVNode("span", { class: "text-hk-gray" }, "HAS"),
                  _createElementVNode("span", { class: "text-hk-red" }, "KREDIET")
                ], -1)),
                _createElementVNode("button", {
                  class: "text-hk-dark p-1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenuOpen.value = false))
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("nav", _hoisted_22, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createVNode(_component_router_link, {
                    key: item.key,
                    to: item.href,
                    class: _normalizeClass([
              'block px-3 py-2.5 rounded-xl text-sm font-bold uppercase tracking-wide transition-colors',
              _ctx.$route.path === item.href
                ? 'bg-hk-red/10 text-hk-red'
                : 'text-hk-dark hover:bg-hk-cream-dark hover:text-hk-red',
            ]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileMenuOpen.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(item.key)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("a", _hoisted_24, [
                  _cache[12] || (_cache[12] = _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    }),
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('footer.maps')), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "block text-center w-full bg-hk-red text-white font-bold uppercase text-sm px-5 py-2.5 rounded-full hover:bg-hk-red-dark transition-colors tracking-wide",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileMenuOpen.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('nav.contact')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      ref: "headerSpacer",
      style: _normalizeStyle({ height: headerHeight.value + 'px' })
    }, null, 4),
    _createElementVNode("main", _hoisted_25, [
      _createVNode(_component_router_view),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "wave-divider bottom-0" }, [
        _createElementVNode("svg", {
          viewBox: "0 0 1440 60",
          preserveAspectRatio: "none",
          class: "w-full h-8 md:h-12"
        }, [
          _createElementVNode("path", {
            d: "M0,0 C360,60 720,20 1080,50 C1260,60 1380,40 1440,30 L1440,60 L0,60 Z",
            fill: "#2D2D2D"
          })
        ])
      ], -1))
    ]),
    _createElementVNode("footer", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-2xl font-extrabold tracking-tight mb-5" }, [
              _createElementVNode("span", { class: "text-white/70" }, "HAS"),
              _createElementVNode("span", { class: "text-hk-red-light" }, "KREDIET")
            ], -1)),
            _createElementVNode("nav", _hoisted_30, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(footerLinks, (link) => {
                return _createVNode(_component_router_link, {
                  key: link.key,
                  to: link.href,
                  class: "text-sm font-medium text-white/70 hover:text-white tracking-wide transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)(link.key)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "font-semibold text-white" }, "HASKREDIET BV", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("p", null, "Sleepstraat 186 A - 9000 Gent", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("p", null, "Tel. 09/267.30.30", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("p", null, [
                _createTextVNode("E-mail: "),
                _createElementVNode("a", {
                  href: "mailto:info@haskrediet.be",
                  class: "text-hk-red-light hover:text-white transition-colors"
                }, "info@haskrediet.be")
              ], -1)),
              _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(t)('footer.hours')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('footer.saturday')), 1)
            ]),
            _createElementVNode("a", _hoisted_34, [
              _cache[19] || (_cache[19] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)('footer.maps')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('global.loanCost')), 1),
          _createElementVNode("span", null, "© 2026 " + _toDisplayString(_unref(t)('footer.rights')), 1)
        ])
      ])
    ])
  ]))
}
}

})